<template>
  <div class="form-group" v-bind:class="{ 'has-error': error }">
    <label v-if="label" :for="name">{{ label }}</label>
    <input type="text"
           v-mask="'#####-###'"
           v-bind:value="value"
           v-on:input="updateValue($event.target.value)"
           v-bind:name="name"
           v-bind:required="required"
           v-bind:placeholder="placeholder"
           class="form-control"
    >
    <span v-if="error"
          class="help-block"
          v-html="error"
    ></span>
  </div>
</template>

<script>
  export default{
    name: 'InputCep',
    props: ['name', 'value', 'required', 'label', 'placeholder', 'error'],
    methods: {
      updateValue (value) {
        this.$emit('input', value)
      }
    }
  }
</script>


// WEBPACK FOOTER //
// InputCep.vue?5ed2828a